import { applyMiddleware, compose, createStore } from 'redux'
import middleware from './middleware'
import rootReducer from './reducers/rootReducer'
import applyDevtoolExtension from './applyDevtoolExtension'
import { getPersistedState } from './persistState'

const enhancer = compose(
    applyMiddleware(...middleware),
    applyDevtoolExtension(),
)

// Get persisted state (partial state with only essential data)
const persistedState = getPersistedState()

// Create store - Redux will merge the persisted state with initial state from reducers
export default createStore(rootReducer, persistedState, enhancer)
